module.exports = __webpack_public_path__ + "static/media/correct_answer_wordchain.06070de3.mp3";